export default function(store) {
  return {

    requireGuest(to, from, next) {
      // Will stop the routing
      next(store.state.users.csrfToken ? {
        path: '/',
        query: {
          redirect: to.fullPath,
        },
      } : true)
    },

    requireUser(to, from, next) {
      // Will login and come back
      next(store.state.users.csrfToken ? true : {
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/router/guard.js